import React from "react";
import { Footer } from "Atoms/";
import { FooterDofaw } from "Atoms/dofaw";
import CookieConsent from "react-cookie-consent";

const Index = (props) => {
  return (
    <>
      {props.children}
      {props.layout === 'dofaw' ? (
        <FooterDofaw />
      ) : (
        <Footer /> 
      )}
      <CookieConsent expires={1} buttonText="OK" contentStyle={{flex: '1 0 100%', marginBottom: 0}}>
        We serve cookies to analyze traffic and customize content on this site.
        By clicking OK in this banner, you agree to the use of cookies.{" "}
        <a
          href="https://portal.ehawaii.gov/page/privacy-policy"
          style={{ color: "#a9bb39" }}
        >
          Privacy Policy
        </a>
      </CookieConsent>
    </>
  );
};

export default Index;
